
import { useStats } from '@/hooks/useStats';
import { Widget } from '../Widget';

interface CategoryWidgetProps {
  isEditMode?: boolean;
}

export function CategoryWidget({ isEditMode }: CategoryWidgetProps) {
  const { stats, isLoading } = useStats();

  if (isLoading) {
    return (
      <Widget id="category-breakdown" title="Category Breakdown" isEditMode={isEditMode}>
        <div className="animate-pulse space-y-3">
          <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="h-10 bg-slate-200 dark:bg-slate-700 rounded" />
        </div>
      </Widget>
    );
  }

  const categories = Object.entries(stats?.prayers.byCategory ?? {});
  const total = categories.reduce((sum, [, count]) => sum + count, 0);

  const categoryColors = [
    'bg-blue-500',
    'bg-green-500',
    'bg-yellow-500',
    'bg-purple-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-red-500',
    'bg-orange-500',
  ];

  return (
    <Widget id="category-breakdown" title="Category Breakdown" isEditMode={isEditMode}>
      <div className="space-y-3">
        {categories.length === 0 ? (
          <div className="text-center py-8 text-slate-500 dark:text-slate-400">
            No prayers categorized yet
          </div>
        ) : (
          categories
            .sort(([, a], [, b]) => b - a)
            .map(([category, count], index) => {
              const percentage = total > 0 ? Math.round((count / total) * 100) : 0;
              const colorClass = categoryColors[index % categoryColors.length];

              return (
                <div key={category} className="space-y-1">
                  <div className="flex items-center justify-between text-sm">
                    <span className="capitalize text-slate-700 dark:text-slate-300">
                      {category}
                    </span>
                    <span className="font-semibold text-slate-900 dark:text-white">
                      {count} ({percentage}%)
                    </span>
                  </div>
                  <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2">
                    <div
                      className={`${colorClass} h-2 rounded-full transition-all duration-300`}
                      style={{ width: `${percentage}%` }}
                    />
                  </div>
                </div>
              );
            })
        )}
      </div>
    </Widget>
  );
}
